import { render, staticRenderFns } from "./KuaaDashboard.vue?vue&type=template&id=1ec9879c&scoped=true"
import script from "./KuaaDashboard.vue?vue&type=script&lang=js"
export * from "./KuaaDashboard.vue?vue&type=script&lang=js"
import style0 from "./KuaaDashboard.vue?vue&type=style&index=0&id=1ec9879c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9879c",
  null
  
)

export default component.exports